import __BARS from './Bars';
import __MENUS from './Menus';
import __FORMS from './Forms';

const __COMPONENTS = {
    Bars : __BARS,
    Menus : __MENUS,  
    Forms : __FORMS
}

export default __COMPONENTS;
